import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import PlansPage from './pages/PlansPage';
import FinancingPage from './pages/FinancingPage';
import ServiceAreasPage from './pages/ServiceAreasPage';
import ContactPage from './pages/ContactPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import { lazy, Suspense } from 'react';
import ChatWidget from './components/ChatWidget';
import NotFoundPage from './pages/NotFoundPage';
import { usePageSEO } from './hooks/usePageSEO';
import type { ContentSnapshot } from './lib/contentSnapshot';
const AdminPage = lazy(() => import('./pages/AdminPage'));
import BlogListPage from './pages/BlogListPage';
import BlogPostPage from './pages/BlogPostPage';
import LocalServicePage from './pages/LocalServicePage';
import PpcLandingPage from './pages/PpcLandingPage';
import { ContentProvider } from './context/ContentContext';

function PublicLayout({ children }: { children: React.ReactNode }) {
  usePageSEO();
  return (
    <div className="min-h-screen bg-white">
      <a href="#main-content" className="skip-link">Skip to main content</a>
      <Header />
      {children}
      <Footer />
    </div>
  );
}

function App({ initialSnapshot }: { initialSnapshot?: ContentSnapshot }) {
  return (
    <ContentProvider initialSnapshot={initialSnapshot}>
      <Routes>
        <Route path="/admin" element={<Suspense fallback={<div role="status" className="p-8">Loading administration…</div>}><AdminPage /></Suspense>} />
        <Route path="/" element={<PublicLayout><HomePage /></PublicLayout>} />
        <Route path="/plans" element={<PublicLayout><PlansPage /></PublicLayout>} />
        <Route path="/financing" element={<PublicLayout><FinancingPage /></PublicLayout>} />
        <Route path="/service-areas" element={<PublicLayout><ServiceAreasPage /></PublicLayout>} />
        <Route path="/contact" element={<PublicLayout><ContactPage /></PublicLayout>} />
        <Route path="/privacy-policy" element={<PublicLayout><PrivacyPolicyPage /></PublicLayout>} />
        <Route path="/terms-of-service" element={<PublicLayout><TermsOfServicePage /></PublicLayout>} />
        <Route path="/blog" element={<PublicLayout><BlogListPage /></PublicLayout>} />
        <Route path="/blog/:slug" element={<PublicLayout><BlogPostPage /></PublicLayout>} />
        <Route path="/services/:slug" element={<PublicLayout><LocalServicePage /></PublicLayout>} />
        <Route path="/landing/:slug" element={<PpcLandingPage />} />
        <Route path="*" element={<PublicLayout><NotFoundPage /></PublicLayout>} />
      </Routes>
      <ChatWidget />
    </ContentProvider>
  );
}

export default App;
